
(() => {
  if (window.__YOTPO_A11Y_LOYALTY__) return;
  window.__YOTPO_A11Y_LOYALTY__ = true;

  const onReady = (fn) => (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', fn, { once:true })
    : fn();

  onReady(() => {
    const target = document.body;
    const CAMPAIGN_ROOT_SEL = '.yotpo-widget-instance-container';
    const VIP_ROOT_SEL = '.yotpo-vip-tiers-wrapper';

    // ------- Campaign tiles (earn points grid) -------
    const labelFromTile = (tile) => {
      const title = tile.querySelector('.yotpo-title-text');
      if (title?.textContent?.trim()) return title.textContent.trim();
      const li = tile.closest('[role="listitem"]');
      if (li?.getAttribute('aria-label')) return li.getAttribute('aria-label').trim();
      const headline = tile.closest(CAMPAIGN_ROOT_SEL)?.querySelector('.yotpo-container-headline');
      if (headline?.textContent?.trim()) return headline.textContent.trim();
      return 'Campaign item';
    };

    function patchCampaignTile(tile) {
      // IMG icons → meaningful alt
      tile.querySelectorAll('img.yotpo-widget-campaign-widget-custom-icon').forEach(img => {
        const current = (img.getAttribute('alt') || '').trim().toLowerCase();
        if (!current || /^(icon|image|photo)$/.test(current)) {
          img.setAttribute('alt', `${labelFromTile(tile)} icon`);
        }
      });
      // SVG icons → informative if <title>, else decorative
      tile.querySelectorAll('svg.yotpo-widget-campaign-widget-icon').forEach(svg => {
        const title = svg.querySelector('title')?.textContent?.trim();
        if (title) {
          svg.setAttribute('role', 'img');
          svg.removeAttribute('aria-hidden');
          svg.setAttribute('aria-label', title);
        } else {
          svg.setAttribute('aria-hidden', 'true');
          svg.removeAttribute('role');
          svg.removeAttribute('aria-label');
        }
        svg.setAttribute('focusable', 'false');
        svg.removeAttribute('tabindex');
      });
    }

    function runCampaign(root=document) {
      root.querySelectorAll(`${CAMPAIGN_ROOT_SEL} .yotpo-tile`).forEach(patchCampaignTile);
    }

    // ------- Referral hero image -------
    function patchReferralImage(root=document) {
      root.querySelectorAll('.yotpo-widget-referral-widget img.yotpo-right-align-image').forEach(img => {
        const title = img.closest('.yotpo-widget-referral-widget')?.querySelector('#yotpoReferralTitleText')?.textContent?.trim() || '';
        const base = 'Kids holding a pack of YumEarth candy';
        img.setAttribute('alt', title ? `${base}. ${title}.` : base);
        img.removeAttribute('aria-hidden');
        img.removeAttribute('tabindex');
      });
    }

    // ------- VIP tiers -------
    const getTierName = (tierEl) => tierEl.querySelector('.yotpo-vip-tier-name')?.textContent?.trim() || 'VIP tier';

    function patchTier(tierEl) {
      // Tier icon alt
      tierEl.querySelectorAll('img.yotpo-vip-tier-icon').forEach(img => {
        const current = (img.getAttribute('alt') || '').trim().toLowerCase();
        if (!current || current === 'icon' || current === 'image') {
          img.setAttribute('alt', `${getTierName(tierEl)} icon`);
        }
        img.removeAttribute('tabindex');
      });
      // Decorative checkmarks
      tierEl.querySelectorAll('svg.yotpo-benefits-check-icon').forEach(svg => {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.removeAttribute('role');
        svg.removeAttribute('aria-label');
        svg.removeAttribute('tabindex');
      });
      // Label card
      const nameEl = tierEl.querySelector('.yotpo-vip-tier-name');
      if (nameEl) {
        if (!nameEl.id) nameEl.id = `vip-tier-name-${Math.random().toString(36).slice(2)}`;
        tierEl.setAttribute('aria-labelledby', nameEl.id);
        // If aria-level present, ensure role=heading
        if (nameEl.hasAttribute('aria-level') && nameEl.getAttribute('role') !== 'heading') {
          nameEl.setAttribute('role', 'heading');
        }
      } else {
        tierEl.setAttribute('aria-label', getTierName(tierEl));
      }
      // Remove stray list roles
      tierEl.querySelectorAll('ul[role], li[role]').forEach(el => el.removeAttribute('role'));
    }

    function runVip(root=document) {
      root.querySelectorAll(VIP_ROOT_SEL).forEach(wrapper => {
        if (!wrapper.getAttribute('aria-label') && !wrapper.getAttribute('aria-labelledby')) {
          wrapper.setAttribute('aria-label', 'VIP tiers');
        }
        wrapper.querySelectorAll('.yotpo-vip-tier').forEach(patchTier);
      });
    }

    // ------- Redemption options carousel -------
    function fixRedemptionListRoles(root=document) {
      // Find redemption options lists with role="list"
      root.querySelectorAll('.yotpo-redemption-options-list[role="list"]').forEach(list => {
        // Check if there are elements between the list and listitems (like swiper containers)
        const listItems = list.querySelectorAll('[role="listitem"]');
        if (listItems.length > 0) {
          // Check if any listitem is not a direct child of the list
          const hasIntermediateElements = Array.from(listItems).some(item => {
            const parent = item.parentElement;
            return parent !== list && !list.contains(parent) || 
                   (parent !== list && list.contains(parent) && parent !== list);
          });
          
          if (hasIntermediateElements) {
            // Remove the list role from the container
            list.removeAttribute('role');
            // Remove listitem roles from all items
            listItems.forEach(item => item.removeAttribute('role'));
          }
        }
      });
    }

    // First run
    runCampaign(document);
    patchReferralImage(document);
    runVip(document);
    fixRedemptionListRoles(document);

    // Observe mutations specific to loyalty elements
    const mo = new MutationObserver(muts => {
      let touched = false;
      for (const m of muts) {
        if (m.addedNodes && m.addedNodes.length) { touched = true; break; }
      }
      if (touched) {
        runCampaign(document);
        patchReferralImage(document);
        runVip(document);
        fixRedemptionListRoles(document);
      }
    });
    mo.observe(target, { childList:true, subtree:true });
  });
})();
